import React from 'react';

import { JRCTabs, JRCTabPanel, ItemEntriesProps } from 'components/JRCTabs/JRCTabs';
import { JRCButton } from 'components/JRCButton/JRCButton';
import { useIntl, FormattedMessage, IntlShape } from 'react-intl';

import { JRCFolders } from 'components/JRCFolders/JRCFolders';
import { arrayUniqueByUri } from 'utils/utils.array';

import styled from 'styled-components';

import jamespot, { AudienceAutocomplete, jFolderList } from 'jamespot-user-api';

export const CSSViewsWrapper = styled.div`
    max-height: 700px;
    overflow: auto;
`;

const tabEntries = (views: any, intl: IntlShape) => {
    const definition: any = {
        folder: { title: intl.formatMessage({ id: 'GLOBAL_File_Bank' }) },
    };

    const entries: ItemEntriesProps[] = [];
    views.map((name: string) => {
        if (definition[name] !== undefined) {
            entries.push({ key: String(name), label: definition[name].title });
        }
    });

    return entries;
};

export type AVProps = {
    views: Array<'folder' | 'user' | 'group' | 'community'>;
    initialValues: AudienceAutocomplete[];
    onConfirm: (values: any) => void;
};

const folderToAutocomplete = (arr: jFolderList[]): AudienceAutocomplete[] => {
    return arr.map((folder) => {
        return {
            id: String(folder.id),
            uri: folder.uri,
            shortUri: folder.uri,
            title: folder.title,
            name: folder.title,
            mainType: folder.mainType,
            type: folder.type,
            label: folder.title,
            cssClass: '',
            cssColor: '',
            class: '',
        };
    });
};

const JRCInputAutocompleteViews = ({ views, initialValues, onConfirm }: AVProps) => {
    const intl = useIntl();

    const [activeItem, setActiveItem] = React.useState<string>(views[0] || '');
    const [localValues, setLocalValues] = React.useState<AudienceAutocomplete[]>([]);

    return (
        <>
            <JRCTabs
                direction="horizontal"
                entries={tabEntries(views, intl)}
                activeItem={activeItem}
                callback={(item) => setActiveItem(item)}
            />
            <JRCTabPanel active={activeItem === 'folder'}>
                <CSSViewsWrapper>
                    <JRCFolders
                        handlers={{ filebank: jamespot.filebank }}
                        initialFolders={[...initialValues]
                            .filter((el) => el.type === 'rootFolder' || el.type === 'folder')
                            .map((el) => el.uri)}
                        onSelectFolder={(folders) => {
                            setLocalValues(arrayUniqueByUri(initialValues, folderToAutocomplete(folders)));
                        }}></JRCFolders>
                </CSSViewsWrapper>
            </JRCTabPanel>
            <JRCButton
                type="button"
                color="primary"
                onClick={() => {
                    onConfirm(localValues);
                }}>
                <FormattedMessage id="GLOBAL_Confirm" />
            </JRCButton>
        </>
    );
};

export { JRCInputAutocompleteViews };
